import type { Theme } from '@mui/material/styles';

export const isLightTheme = (theme: Theme): boolean =>
  theme.palette.mode === 'light';
